export const environment = {
    apiBaseUrl: 'https://tctapi.xenovex.com',
  // apiBaseUrl: 'http://devtctapi.xenovex.com',
  // apiBaseUrl: 'http://139.59.46.102:8662',
  // apiBaseUrl: 'http://192.168.10.160:5000',

  //apiBaseUrl: 'http://192.168.10.160:5000',
  //apiBaseUrl: 'http://localhost:5000',
  tokenEndPoint: '/api/token',
  production: false,
  environment: 'Local',
  showEnvironment: true,
  year: 1970,
};
